import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { ApiService } from './api.service';

@NgModule({
    imports: [HttpClientModule],
    providers: [ApiService]
})
export class ApiModule {
    static forRoot(): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            exports:  [HttpClientModule],
        } as ModuleWithProviders<ApiModule>;
    }
}
